import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

// --- GLOBAL ERROR HANDLERS ---
// Unhandled Promise Rejection Handler
window.addEventListener('unhandledrejection', (event) => {
  console.error('❌ Unhandled Promise Rejection:', event.reason);
  // Prevent default browser error handling
  event.preventDefault();
  // Log error but don't crash the app
});

// Global Error Handler
window.addEventListener('error', (event) => {
  console.error('❌ Global Error:', event.error);
  // Log error but don't crash the app
});

// --- STORAGE CLEANUP ON INIT ---
// Clear corrupt localStorage data on app initialization
const cleanupCorruptStorage = () => {
  try {
    const keys = ['talepia_current_user', 'talepia_cookie_consent'];
    keys.forEach(key => {
      try {
        const value = localStorage.getItem(key);
        if (value) {
          // Try to parse to check if valid JSON
          JSON.parse(value);
        }
      } catch (e) {
        // Corrupt data found - remove it
        console.warn(`⚠️ Removing corrupt ${key} from localStorage`);
        localStorage.removeItem(key);
        try {
          sessionStorage.removeItem(key);
        } catch (e) { }
      }
    });
  } catch (e) {
    console.error('⚠️ Storage cleanup failed:', e);
  }
};

// Run cleanup before React initialization
cleanupCorruptStorage();

// Register Service Worker for PWA with error recovery
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // First, unregister any existing service workers to clear old cache
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      // Only unregister if there are old registrations or if forced
      const forceUnregister = localStorage.getItem('sw_force_unregister') === 'true';

      if (forceUnregister && registrations.length > 0) {
        console.log('⚠️ Unregistering old service workers...');
        Promise.all(registrations.map(reg => reg.unregister())).then(() => {
          localStorage.removeItem('sw_force_unregister');
          registerServiceWorker();
        });
      } else {
        registerServiceWorker();
      }
    });
  });

  const registerServiceWorker = () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('✅ SW registered:', registration);

        // Check for updates periodically
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // New SW available, reload to activate
                console.log('🔄 New SW available, reloading...');
                localStorage.setItem('sw_force_unregister', 'false');
                window.location.reload();
              }
            });
          }
        });
      })
      .catch((registrationError) => {
        console.error('❌ SW registration failed:', registrationError);
        // If registration fails, try to unregister and retry once
        navigator.serviceWorker.getRegistrations().then((registrations) => {
          if (registrations.length > 0) {
            console.log('⚠️ Unregistering failed SWs and retrying...');
            Promise.all(registrations.map(reg => reg.unregister())).then(() => {
              setTimeout(() => {
                navigator.serviceWorker.register('/sw.js').catch((err) => {
                  console.error('❌ SW retry registration failed:', err);
                });
              }, 1000);
            });
          }
        });
      });
  };
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);

// Error handling for initial render
try {
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  );
} catch (error) {
  console.error('Failed to render app:', error);
  rootElement.innerHTML = `
    <div style="min-height: 100vh; display: flex; align-items: center; justify-content: center; background: #0F172A; color: white; font-family: system-ui; text-align: center; padding: 20px;">
      <div>
        <h1 style="font-size: 24px; margin-bottom: 16px;">Yükleme Hatası</h1>
        <p style="margin-bottom: 24px; opacity: 0.8;">Sayfa yüklenirken bir hata oluştu.</p>
        <button onclick="window.location.reload()" style="padding: 12px 24px; background: #4F46E5; color: white; border: none; border-radius: 8px; cursor: pointer; font-weight: bold;">
          Sayfayı Yenile
        </button>
      </div>
    </div>
  `;
}